module.exports = __webpack_public_path__ + "img/30f8.73195c72.jpg";